import React from "react";
import { useLocation, Link } from "react-router-dom";

const EmailVerification = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const status = params.get("status");
const role = params.get("role"); // student | tutor

  const isSuccess = status === "success";

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={isSuccess ? styles.iconSuccess : styles.iconError}>
          {isSuccess ? "✔" : "✖"}
        </div>

        <h1 style={isSuccess ? styles.success : styles.error}>
          {isSuccess ? "Email Verified!" : "Verification Failed"}
        </h1>

        <p style={styles.text}>
          {/* {isSuccess
            ? "Your email has been successfully verified. Your account is pending admin approval."
            : "The verification link is invalid or has expired. Please try again."} */}
            {isSuccess && role === "tutor" &&
    "Your email has been successfully verified. Your account is pending admin approval."}

  {isSuccess && role === "student" &&
    "Your email has been successfully verified. You can now log in to your account."}
        </p>

        {isSuccess && (
          <Link to="/login" style={styles.button}>
            Go to Login
          </Link>
        )}
      </div>
    </div>
  );
};

/* -------------------- STYLES -------------------- */

const styles = {
  wrapper: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #667eea, #764ba2)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },

  card: {
    background: "#fff",
    width: "100%",
    maxWidth: "420px",
    padding: "30px 25px",
    borderRadius: "14px",
    textAlign: "center",
    boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
    animation: "fadeIn 0.6s ease-in-out",
  },

  iconSuccess: {
    width: "70px",
    height: "70px",
    margin: "0 auto 15px",
    borderRadius: "50%",
    background: "#28a745",
    color: "#fff",
    fontSize: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  iconError: {
    width: "70px",
    height: "70px",
    margin: "0 auto 15px",
    borderRadius: "50%",
    background: "#dc3545",
    color: "#fff",
    fontSize: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  success: {
    color: "#28a745",
    fontSize: "24px",
    marginBottom: "10px",
  },

  error: {
    color: "#dc3545",
    fontSize: "24px",
    marginBottom: "10px",
  },

  text: {
    fontSize: "15px",
    color: "#555",
    lineHeight: "1.6",
    marginBottom: "25px",
  },

  button: {
    display: "inline-block",
    padding: "12px 28px",
    background: "linear-gradient(135deg, #667eea, #764ba2)",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "30px",
    fontWeight: "600",
    fontSize: "15px",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  },
};

export default EmailVerification;
